import React, { useState, useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import Paper from "@material-ui/core/Paper";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import axios from "axios";
import Box from "@material-ui/core/Box";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Alert, AlertTitle } from "@material-ui/lab";
import { Link } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import Typography from "@material-ui/core/Typography";
import ReCAPTCHA from "react-google-recaptcha";

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: "lg",
    padding: 0,
    margin: 0,
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  rootCard: {
    maxWidth: 450,
    backgroundColor: "green",
  },
  inputsenores: {
    paddingTop: "3px",
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  textfield: {
    paddingTop: "0px",
    paddingBottom: "0px",
    paddingLeft: "8px",
    paddingRight: "8px",
  },
  selectJG: {
    "&::before": {
      paddingTop: "3px",
      backgroundColor: "red",
    },
  },
  botonLogin: {
    marginLeft: "0px",
    marginRight: "0px",
    width: "100%",
    backgroundColor: "#016AA2",
  },
  GridLogin: {
    maxWidth: "400px",
  },
}));

export default function Login(props) {
  const classes = useStyles();
  const [agencies, setAgencies] = React.useState();
  const [agents, setAgents] = React.useState();
  const [flagAuth, setFlagAuth] = React.useState(false);
  const [disableBook, setDisableBook] = React.useState(false);
  const [agencySelected, setAgencySelected] = React.useState("");
  const [agentSelected, setAgentSelected] = React.useState("");
  const [searchName, setSearchName] = React.useState("");
  const [searchAgent, setSearchAgent] = React.useState("");
  const [openMessage, setOpenMessage] = React.useState(false);
  const [searchPassword, setSearchPassword] = React.useState("");
  const [searchContrasena, setSearchContrasena] = React.useState("24twxs");
  const [registered, setRegistered] = React.useState(false);
  const [condiciones, setCondiciones] = React.useState(false);
  const [nombreApellido, setNombreApellido] = React.useState("");
  const [telefono, setTelefono] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [mensaje, setMensaje] = React.useState("");
  const [captchaValido, setCaptchaValido] = useState(false);
  const [urlCondiciones, seturlCondiciones] = useState("");
  const [LabelCondiciones, setLabelCondiciones] = useState("");

  //------------------------- USE EFFECT
  useEffect(() => {
    let disBook = false;
    if (captchaValido) {
      if (registered === false) {
        if (
          nombreApellido !== "" &&
          telefono !== "" &&
          email !== "" &&
          condiciones
        ) {
          disBook = true;
        } else {
          disBook = false;
        }
      } else {
        if (flagAuth === true && condiciones) {
          disBook = true;
        } else {
          disBook = false;
        }
      }      
    }
    switch (props.AgenciaWeb) {
      case 'Ibero':
        seturlCondiciones("https://www.iberolunatravel.com/ContenidoWeb/Paginas/Ibero/home/terminos-clausulas.aspx");    
        setLabelCondiciones("Acepta terminos y condiciones de Iberoluna, C.A."); 
        break;
      case 'MC':
        seturlCondiciones("https://atom.travel/web/condiciones-generales-atom-travel.pdf");
        setLabelCondiciones("Acepta terminos y condiciones de MC, C.A.");           
        break;
      default:
        seturlCondiciones("https://atom.travel/web/condiciones-generales-atom-travel.pdf");
      setLabelCondiciones("Acepta terminos y condiciones de Atom Travel, C.A.");       
        break; 
    }
   /*  if (props.AgenciaWeb === "Ibero") {
      seturlCondiciones("https://www.iberolunatravel.com/ContenidoWeb/Paginas/Ibero/home/terminos-clausulas.aspx");    
      setLabelCondiciones("Acepta terminos y condiciones de Iberoluna, C.A.");
    }
    else {
      seturlCondiciones("https://atom.travel/web/condiciones-generales-atom-travel.pdf");
      setLabelCondiciones("Acepta terminos y condiciones de Atom Travel, C.A.");        
    } */
    setDisableBook(disBook);
    let login = {
      agencySelected: agencySelected,
      agentSelected: agentSelected,
      nombreApellido: nombreApellido,
      telefono: telefono,
      email: email,
      mensaje: mensaje,
      flagAuth: disBook,
      contrasena: searchContrasena,
      registrado: registered
    };
    props.onChange(login);
  }, [
    agencySelected,
    agentSelected,
    nombreApellido,
    telefono,
    email,
    registered,
    condiciones,
    searchContrasena,
    captchaValido
  ]);

  useEffect(() => {
    SearchAgency();
  }, []);
  //-------- USE EFFECT (FIN)

  //------------------------- API
  const SearchAgency = () => {
    const url = "https://webtravel2-online.com/APIatom/api/Agencias?Nombre=";
    axios
      .get(url, {
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((response) => {
  /*       console.log("response.data");
        console.log(response.data); */
        setAgencies(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const SearchAgents = () => {
    const url =
      "https://webtravel2-online.com/APIatom/api/Agentes?Agencia=" +
      agencySelected.NOMBRE;
    axios
      .get(url, {
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((response) => {
/*         console.log("response.data");
        console.log(response.data); */
        setAgents(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const loginAgency = () => {
    setAgents([]);
    const url =
      "https://webtravel2-online.com/APIatom/api/Chequeo?codigo=" +
      searchPassword +
      "&nombre=" +
      agencySelected.NOMBRE;
    axios
      .get(url, {
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((response) => {
        setFlagAuth(false);
        console.log("Auth");
        console.log(response.data);
        if (response.data.length > 0) {
          if (response.data[0].nombre === agencySelected.NOMBRE) {
            setFlagAuth(true);
            setOpenMessage(false);
            SearchAgents();
          } else {
            setOpenMessage(true);
            setFlagAuth(false);
          }
        } else {
          setOpenMessage(true);
          setFlagAuth(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const captcha = useRef(null);

  const onChangeReCAPTCHA = () => {
    if (captcha.current.getValue()) {
      setCaptchaValido(true);
    }
  };
  //------------------------- API (FIN)

  //------------------------- FUNCIONES

  //-------------------------HANDLERS
  const onChangeHandlerPassword = (event) => {
    setOpenMessage(false);
    setSearchPassword(event.target.value);
  };

  const onChangeHandlerContrasena = (event) => {
    setSearchContrasena(event.target.value);
  };

  const onChangeHandlerAgency = (event) => {
    setOpenMessage(false);
    setSearchName(event.target.value);
  };

  const onChangeHandlerAgent = (event) => {
    setAgentSelected(event.target.value);
  };

  const onChangeHandlerRegistered = (event) => {
    setRegistered(event.target.checked);
  };

  const onChangeHandlerCondiciones = (event) => {
    setCondiciones(event.target.checked);
  };

  const onChangeHandlerNombreApellido = (event) => {
    setNombreApellido(event.target.value);
  };

  const onChangeHandlerTelefono = (event) => {
    setTelefono(event.target.value);
  };

  const onChangeHandlerEmail = (event) => {
    setEmail(event.target.value);
  };

  const onChangeHandlerMensaje = (event) => {
    setMensaje(event.target.value);
  };

  //-------------------------HANDLERS FIN

  //-----------------------------------

  return (
    <div className={classes.root}>
      <Box
        display="flex"
        justifyContent="center"
        m={1}
        p={1}
        bgcolor="background.paper"
      >
        <Box p={1}>
          <Grid
            container
            spacing={2}
            direction="row"
            className={classes.GridLogin}
            justify="center"
            alignItems="center"
          >
              {props.AgenciaWeb !== "Ibero" && props.AgenciaWeb !== "MC" ? (
            <Grid item xs={12}>
              <Paper elevation={0} className={classes.paper}>
                <FormControl component="fieldset">              
                  <FormGroup aria-label="position" row>
                    <FormControlLabel
                      value="agencia"
                      control={
                        <Switch
                          color="primary"
                          checked={registered}
                          onChange={onChangeHandlerRegistered}
                        />
                      }
                      label="¿ Usted es un usuario registrado ?"
                      labelPlacement="start"
                      color="primary"
                    />
                  </FormGroup>
                </FormControl>
              </Paper>
            </Grid>
              ) : ( <fragment></fragment>)
                    }
         {/*    <Grid item xs={12}>
              <TextField
                style={{ backgroundColor: "white", width: "100%" }}
                label="Indique la contraseña"
                margin="dense"
                type="password"
                className={classes.input}
                inputProps={{ "aria-label": "Indique la contraseña" }}
                onChange={onChangeHandlerContrasena}
                variant="outlined"
                size="small"
              />
            </Grid> */}
            {registered && !flagAuth ? (
              <React.Fragment>
                <Grid item xs={12}>
                  {/* <Paper elevation='0' className={classes.paper}> */}
                  <Autocomplete
                    id="free-solo-2-demo"
                    freeSolo
                    disableClearable="false"
                    options={agencies}
                    value={agencySelected}
                    defaultvalue={[""]}
                    onChange={(event, newValue) => {
                      setAgencySelected(newValue);
                    }}
                    classes={{
                      option: classes.option,
                    }}
                    getOptionLabel={(option) => option.NOMBRE}
                    renderOption={(option) => (
                      <React.Fragment>
                        <span style={{ fontSize: "12px" }}>
                          {option.NOMBRE}
                        </span>
                      </React.Fragment>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        style={{ backgroundColor: "white" }}
                        label="Indique agencia de viaje"
                        margin="dense"
                        value={searchName}
                        className={classes.input}
                        onChange={onChangeHandlerAgency}
                        variant="outlined"
                        InputProps={{ ...params.InputProps, type: "search" }}
                        size="small"
                      />
                    )}
                  />

                  {/* </Paper> */}
                </Grid>
                <Grid item xs={8}>
                  {/* <Paper elevation='0' className={classes.paper}> */}
                  <TextField
                    style={{ backgroundColor: "white" }}
                    label="Contraseña"
                    type="password"
                    margin="dense"
                    value={searchPassword}
                    className={classes.input}
                    inputProps={{ "aria-label": "Codigo unico" }}
                    onChange={onChangeHandlerPassword}
                    variant="outlined"
                    size="small"
                  />
                  {/* </Paper> */}
                </Grid>
                <Grid item xs={4} style={{ align: "center" }}>
                  {/* <Paper elevation='0' className={classes.paper}> */}
                  <Button
                    variant="contained"
                    size="medium"
                    color="primary"
                    className={classes.botonLogin}
                    onClick={loginAgency}
                  >
                    Login
                  </Button>
                  {/* </Paper> */}
                </Grid>
                {openMessage ? (
                  <Grid item xs={12}>
                    <Alert severity="error">
                      <AlertTitle>Error</AlertTitle>
                      Contraseña incorrecta !
                    </Alert>
                  </Grid>
                ) : (
                  ""
                )}
              </React.Fragment>
            ) : (
              ""
            )}
            {registered && flagAuth ? (
              <React.Fragment>
                <Grid item xs={12} style={{ align: "center" }}>
                  <Paper elevation="0" className={classes.paper}>
                    <Typography variant="h5" gutterBottom>
                      {agencySelected.NOMBRE}
                    </Typography>
                    <Autocomplete
                      id="free-solo-2-demo"
                      Width="200px"
                      freeSolo
                      disableClearable="false"
                      options={agents}
                      value={agentSelected}
                      onChange={(event, newValue) => {
                        setAgentSelected(newValue);
                        setFlagAuth(true);
                      }}
                      classes={{
                        option: classes.option,
                      }}
                      getOptionLabel={(option) => option.NOMBRE}
                      renderOption={(option) => (
                        <React.Fragment>
                          <span style={{ fontSize: "12px" }}>
                            {option.NOMBRE}
                          </span>
                        </React.Fragment>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          style={{ backgroundColor: "white" }}
                          label="Indique el agente"
                          margin="dense"
                          value={searchAgent}
                          className={classes.input}
                          onChange={onChangeHandlerAgent}
                          variant="outlined"
                          InputProps={{ ...params.InputProps, type: "search" }}
                          size="small"
                        />
                      )}
                    />
                  </Paper>
                </Grid>
              </React.Fragment>
            ) : !registered ? (
              <React.Fragment>
                <Grid item xs={12}>
                  <TextField
                    style={{ backgroundColor: "white", width: "100%" }}
                    label="Nombre y Apellido"
                    margin="dense"
                    value={nombreApellido}
                    className={classes.input}
                    inputProps={{ "aria-label": "Nombre y Apellido" }}
                    onChange={onChangeHandlerNombreApellido}
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    style={{ backgroundColor: "white" }}
                    label="Teléfono"
                    margin="dense"
                    type="tel"
                    value={telefono}
                    className={classes.input}
                    inputProps={{ "aria-label": "Teléfono" }}
                    onChange={onChangeHandlerTelefono}
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    style={{ backgroundColor: "white" }}
                    label="Email"
                    type="email"
                    margin="dense"
                    value={email}
                    className={classes.input}
                    inputProps={{ "aria-label": "Email" }}
                    onChange={onChangeHandlerEmail}
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    style={{ backgroundColor: "white", width: "100%" }}
                    rows={2}
                    label="Mensaje"
                    width="100%"
                    multiline={true}
                    margin="dense"
                    value={mensaje}
                    className={classes.input}
                    inputProps={{ "aria-label": "Mensaje" }}
                    onChange={onChangeHandlerMensaje}
                    variant="outlined"
                    size="small"
                  />
                </Grid>
              </React.Fragment>
            ) : (
              ""
            )}
          </Grid>
        </Box>
      </Box>
      <Box
        display="flex"
        justifyContent="center"
        m={1}
        p={1}
        css={{ width: "100%" }}
      >
        <FormControl component="fieldset">
          <FormGroup aria-label="position" row>
            <FormControlLabel
              value="agencia"
              control={
                <Checkbox
                  color="primary"
                  checked={condiciones}
                  onChange={onChangeHandlerCondiciones}
                />
              }
              label={
                <Link href={urlCondiciones} target="_blank">
                  {LabelCondiciones}
                </Link>
              }
              labelPlacement="start"
              color="primary"
            />
          </FormGroup>
        </FormControl>
        </Box>
        <Box
          display="flex"
          justifyContent="center"
          m={1}
          p={1}
          css={{ width: "100%" }}
        >
          <FormControl component="fieldset">
            <FormGroup aria-label="position" row>
              <ReCAPTCHA
                key="Captcha"
                ref={captcha}
                sitekey="6LdQ2lccAAAAAJODGbLJ0noOwKupX-rnlagJ2ggd"
                onChange={onChangeReCAPTCHA}
              />
            </FormGroup>
          </FormControl>
        </Box>
     
    </div>
  );
}
